import React from 'react';

const showCategory = (categories, selected) => {
  for (let i = 0; i < categories.length; i++) {
    if (categories[i].id === selected) {
      return <span className="tour-page__info-content">{categories[i].name}</span>
    }
  }
  return null;
};

export {showCategory};


// WEBPACK FOOTER //
// ./src/app/containers/TourPage/components/Templates/utils.js